var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    rx: 9.5,
    fill: "#0061E4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1619"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-1",
    d: "M11.5769 4.56641H7.42206C6.57425 4.56641 5.84769 4.86995 5.33552 5.41942C4.82699 5.965 4.56641 6.71316 4.56641 7.54236V11.4571C4.56641 12.2856 4.82537 13.0339 5.33347 13.5798C5.84535 14.1298 6.57222 14.4331 7.42206 14.4331H11.5765C12.4263 14.4331 13.1533 14.1298 13.6654 13.5799C14.1738 13.034 14.4331 12.2858 14.4331 11.4571V7.54236C14.4331 6.71371 14.1738 5.96547 13.6655 5.41961C13.1535 4.86973 12.4266 4.56641 11.5769 4.56641Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-3",
    d: "M11.1252 10.466L9.5 9.49639V7.40625",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/inProgress.54edc9d0c6ca1217791f3aef4fc4a377.svg";
export { ForwardRef as ReactComponent };